import React from 'react'
import DocumentTitle from 'react-document-title';
import { Switch, Route } from 'react-router'
import Confirm from './Confirm'
import Request from './Request'
import Success from './Success'

const Reset = ({ match }) => (
  <div>
      <DocumentTitle title="Paroles iestatīšana - e-BML" />
      <Switch>
        <Route path={`${match.url}/request/`} component={Request}/>
        <Route path={`${match.url}/confirm/:uid/:token/`} component={Confirm}/>
        <Route path={`${match.url}/success/`} component={Success}/>
      </Switch>
  </div>
);

export default Reset;


// WEBPACK FOOTER //
// ./src/scenes/Reset/index.js